import {newNotification} from "./notifications";
import {sessionService} from "redux-react-session";
import fetch from "isomorphic-fetch";
import {API2_URL, VERSION_GROUPS_PHASES_REQUEST, VERSION_GROUPS_PHASES_EDIT, VERSION_GROUPS_PHASES_CLEAR, VERSION_GROUPS_PHASES_FAIL} from "../store/config";
import _ from 'lodash';
import {modalitiesList} from "./modalities";
import {phasesList} from "./phases";
import {fetchGroupsPhasesList} from "./groups_phases";
import {fetchNotificationsTypesList} from "./notifications_types";
import {fetchProjectsList} from "./projects";
import {entitiesList} from "./entities";
import {fetchSurveysList} from "./surveys";

export const fetchVersionGroupPhaseComplete = (year, id) => (dispatch) => {
	dispatch(versionGroupPhaseRequest());
	dispatch(versionGroupPhaseClear());
	return dispatch(modalitiesList())
		.then((mod) => {
			if(!_.isEmpty(mod.payload)){
				return dispatch(phasesList())
					.then((phases) => {
						if(!_.isEmpty(phases.payload)){
							return dispatch(fetchSurveysList())
								.then((surveys) => {
									if(!_.isEmpty(surveys.payload)){
										return dispatch(fetchGroupsPhasesList())
											.then((groups) => {
												if(!_.isEmpty(groups.payload)){
													return dispatch(fetchNotificationsTypesList())
														.then((types) => {
															if(!_.isEmpty(types.payload)){
																return dispatch(fetchVersionGroupsPhases(year, id))
																	.then((edit) => {
																		if(!_.isEmpty(edit.payload) && !edit.payload.all_projects){
																			dispatch(entitiesList());
																			return dispatch(fetchProjectsList(edit.payload.version_phase_group.version_id))
																				.then((projects) => {
																					if(_.isEmpty(projects.payload)){
																						return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));
																					}
																				})
																		}
																	})
															}else {
																return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));
															}
														})
												}else {
													return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));
												}
											})
									}else {
										return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));
									}
								})
						}else {
							return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));
						}
					})
			}else {
				return dispatch(versionGroupPhaseFail('Carga de proceso incompleta'));
			}
		})
}

export const fetchVersionGroupsPhases = (year,id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				//dispatch(versionGroupPhaseRequest());
				//dispatch(versionGroupPhaseClear());

				//return fetch(`${API2_URL}/versions/${year}/phases-groups/${id}?include[0]=status&include[1]=phases.version_phase&include[2]=version_phase_group&include[3]=notifications_types_versions_phases.notification_type&include[4]=projects`, options)
				return fetch(`${API2_URL}/versions/${year}/phases-groups/${id}?include[0]=status&include[phases][version_phase][survey_version_phases][0]=survey&include[phases][version_phase][survey_version_phases][1]=modality&include[1]=version_phase_group&include[2]=notifications_types_versions_phases.notification_type&include[3]=projects`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(versionGroupPhaseEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(versionGroupPhaseFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const versionGroupsPhasesEditSave = (year, values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(versionGroupPhaseRequest());

				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				return fetch(`${API2_URL}/versions/${year}/phases-groups/${values.id}?include[0]=status&include[phases][version_phase][survey_version_phases][0]=survey&include[phases][version_phase][survey_version_phases][1]=modality&include[1]=version_phase_group&include[2]=notifications_types_versions_phases.notification_type&include[3]=projects&_method=PUT`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message, type: "success"}));
							return dispatch(versionGroupPhaseEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(versionGroupPhaseFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

const versionGroupPhaseRequest = () => {
	return {
		type: VERSION_GROUPS_PHASES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const versionGroupPhaseEditData = (json) => {
	let phases = []; let notifications_types = [];

	_.mapKeys(json.data.notifications_types_versions_phases, (item) => {
		return notifications_types.push({ntvp_id: item.id, id: item.notification_type_id, name: item.notification_type.name, body: item.body, modality_id: item.modality_id});
	})

	let response = {
		...json.data,
		notifications_types,
		all_projects: Boolean(json.data.version_phase_group.all_projects),
		assign_codes: Boolean(json.data.version_phase_group.assign_codes),
		show_current_revision: Boolean(json.data.version_phase_group.show_current_revision),
		start_date: json.data.version_phase_group.start_date,
		end_date: json.data.version_phase_group.end_date,
		report_start_date: json.data.version_phase_group.report_start_date,
		report_end_date: json.data.version_phase_group.report_end_date,
		is_closing: json.data.version_phase_group.is_closing
	};

	_.mapKeys(json.data.phases, (phase) => {
		if(phase){
			return phases.push({
				id: phase.id,
				name: phase.name,
				start_date: phase.version_phase.start_date,
				end_date: phase.version_phase.end_date,
				report_start_date: phase.version_phase.report_start_date,
				report_end_date: phase.version_phase.report_end_date,
				require_survey: phase.require_survey,
				survey_version_phases: phase.require_survey ? phase.version_phase.survey_version_phases:[],
				type: phase.type
			});
		}
	})

	if(!_.isEmpty(phases)){
		response.phases = phases
	}

	return {
		type: VERSION_GROUPS_PHASES_EDIT,
		isFetching: false,
		payload: response,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const versionGroupPhaseClear = () => {
	return {
		type: VERSION_GROUPS_PHASES_CLEAR,
		isFetching: false,
		payload: {
			all_projects: true,
			phases:[]
		},
		timestamp: Date.now()
	}
}

const versionGroupPhaseFail = (error) => {
	return {
		type: VERSION_GROUPS_PHASES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/version_groups_phases.js